import { createAction, props } from '@ngrx/store';

export const SetExpandedProjectId = createAction('[UI] set expanded project id', props<{ item: string }>());
